import processDesign from "../../data/processDesign";
import articles from "../../data/articles";

processDesign.data.map(obj => {
  obj.article = articles.data.find(art => art.id === obj.articleId);
  return obj;
});

const INITIAL_STATE = {
  data: processDesign.data
};

const loadProcessDedingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ADD_PROCESS_DESING":
      return { ...state, data: [...state.data, action.desing] };
    case "UPDATE_PROCESS_DESING":
      return {
        ...state,
        data: [...state.data.map(d => (d.id === action.desing.id ? action.desing : d))]
      };
    case "DELETE_DESING":
      return {
        ...state,
        data: [...state.data.filter(d => d.id !== action.state.id)]
      };
    default:
      return state;
  }
};

export default loadProcessDedingsReducer;
